import { useContext, useState } from "react";
import { Link } from "react-router-dom";

// MUI components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Custom components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Layout and assets
import BasicLayoutLanding from "layouts/authentication/components/BasicLayoutLanding";
import bgImage from "assets/images/bg-sign-in-basic.jpeg";

// Auth service and context
import AuthService from "services/auth-service";
import { AuthContext } from "context";

function Login() {
  const authContext = useContext(AuthContext);

  const [inputs, setInputs] = useState({
    mobile: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    mobileError: false,
    passwordError: false,
  });

  const [credentialsError, setCredentialsError] = useState(null);
  const [rememberMe, setRememberMe] = useState(false);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const changeHandler = (e) => {
    const { name, value } = e.target;

    if (name === "mobile") {
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 10) {
        setInputs((prev) => ({ ...prev, mobile: digits }));
      }
    } else {
      setInputs((prev) => ({ ...prev, [name]: value }));
    }
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    setErrors({
      mobileError: false,
      passwordError: false,
    });
    setCredentialsError(null);

    let isValid = true;

    if (!/^\d{10}$/.test(inputs.mobile)) {
      setErrors((prev) => ({ ...prev, mobileError: true }));
      isValid = false;
    }

    if (inputs.password.trim().length < 6) {
      setErrors((prev) => ({ ...prev, passwordError: true }));
      isValid = false;
    }

    if (!isValid) return;

    const userData = {
      mobile: `+91${inputs.mobile}`,
      password: inputs.password,
    };

    try {
      const response = await AuthService.login(userData);


      // console.log("Access Token:", response.access_token);
      // console.log("Refresh Token:", response.refresh_token);


      authContext.login(response.access_token);
      sessionStorage.setItem('token', response.access_token)

      localStorage.setItem("access_token", response.access_token);
      // localStorage.setItem("refresh_token", response.refresh_token);
    } catch (err) {
      console.error("Login error:", err);
      if (err?.message) {
        setCredentialsError(err.message);
      } else {
        setCredentialsError(err.errors?.[0]?.detail || "Invalid credentials.");
      }
    }

    setInputs({ mobile: "", password: "" });
  };

  return (
    <BasicLayoutLanding image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>

        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={submitHandler}>
            <MDBox mb={2}>
              <MDInput
                type="tel"
                label="Mobile"
                fullWidth
                name="mobile"
                value={inputs.mobile}
                onChange={changeHandler}
                error={errors.mobileError}
                placeholder="Enter 10-digit mobile number"
              />
            </MDBox>

            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                name="password"
                value={inputs.password}
                onChange={changeHandler}
                error={errors.passwordError}
              />
            </MDBox>

            <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox>

            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="info" fullWidth type="submit">
                Sign in
              </MDButton>
            </MDBox>

            {credentialsError && (
              <MDTypography variant="caption" color="error" fontWeight="light">
                {credentialsError}
              </MDTypography>
            )}

            <MDBox mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Don&apos;t have an account?{" "}
                <MDTypography
                  component={Link}
                  to="/auth/register"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayoutLanding>
  );
}

export default Login;